// extracted by css-extract-rspack-plugin
export default {"a0":"SimplePaperPodcast-cls1_K2n","cls1":"SimplePaperPodcast-cls1_3LJ","cls2":"SimplePaperPodcast-cls2_Ejn SimplePaperPodcast-cls1_3LJ"};